import React from 'react'

class PricingChart extends React.Component {
  render() {
    const {
      match: {
        params: {chart},
      },
    } = this.props

    let chartUrl =
      'https://s.tradingview.com/cmewidgetembed/?symbol=' +
      chart +
      '&amp;interval=D&amp;hidesidetoolbar=0&amp;symboledit=0&amp;saveimage=1&amp;toolbarbg=E4E8EB&amp;studies=%5B%5D&amp;style=0&amp;studies_overrides=%7B%7D&amp;overrides=%7B%7D&amp;enabled_features=%5B%5D&amp;disabled_features=%5B%5D&amp;venue=0&amp;utm_source=www.cmegroup.com&amp;utm_medium=widget&amp;utm_campaign=chart&amp;utm_term=' +
      chart
    return (
      <div style={{height: '100%'}}>
        <iframe
          id="tradingview_e32f0"
          title="Pricing Chart"
          src={chartUrl}
          style={{
            width: '100%',
            height: '100%',
            margin: '0 !important',
            padding: '0 !important',
          }}
          frameBorder="0"
          allowtransparency="true"
          scrolling="no"
          allowFullScreen=""
        />
      </div>
    )
  }
}

export default PricingChart



// WEBPACK FOOTER //
// ./src/components/futures/pricingChart.js